export interface VoluntaryDisclosureTableColumn {
    key: string;
    title: string;
    isAmount?: boolean;
    order: number;
}

/** API field keys from /undisclosed-income/get-all */
export const VOLUNTARY_DISCLOSURE_INCOME_HEAD_KEY = 'incomeHead';
export const VOLUNTARY_DISCLOSURE_PARTICULARS_KEY = 'particulars';
export const VOLUNTARY_DISCLOSURE_ASSESSMENT_YEAR_KEY = 'incomeAy';
export const VOLUNTARY_DISCLOSURE_NET_INCOME_KEY = 'netIncome';

export const INCOME_FORM_VOLUNTARY_DISCLOSURE_COLUMNS: VoluntaryDisclosureTableColumn[] = [
    { key: VOLUNTARY_DISCLOSURE_INCOME_HEAD_KEY, title: 'Heads of Income', order: 1 },
    { key: VOLUNTARY_DISCLOSURE_PARTICULARS_KEY, title: 'Particulars', order: 2 },
    { key: VOLUNTARY_DISCLOSURE_ASSESSMENT_YEAR_KEY, title: 'Assessment Year of Earning', order: 3 },
    { key: VOLUNTARY_DISCLOSURE_NET_INCOME_KEY, title: 'Net Income', isAmount: true, order: 4 },
];
